import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import UploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const CircleUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
}) => {
  const settingsApplied = image.imagePosition !== 'right';

  return (
    <UploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={false}
      showSettings
      showPreview={false}
      circularImage
      imgRatioX={61}
      imgRatioY={61}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          imageIndex={imageIndex}
          setImages={setImages}
          image={image}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(CircleUploadedImageRow);
